/** authModal + aiDashboard for pa, te, ta, mr, bn, kn (en/hi live in translations.js). */

import { buildSwitchCredentialLoginLabel } from "./credentialUiLabels";

const AUTH_MODAL = {
  pa: {
    betterMeTitle: "ਬਿਹਤਰ ਸਿਹਤ ਇੱਥੋਂ ਸ਼ੁਰੂ",
    welcomeSubtitle: "ਸਵਾਗਤ! ਜਾਰੀ ਰੱਖਣ ਲਈ ਸਾਈਨ ਅੱਪ ਜਾਂ ਲਾਗਇਨ ਕਰੋ",
    progressTracking: "ਪ੍ਰਗਤੀ ਟ੍ਰੈਕਿੰਗ",
    progressTrackingDesc: "ਤੁਹਾਡੇ ਸਿਹਤ ਵਾਇਟਲਸ ਲਈ ਵਿਜ਼ੂਅਲ ਚਾਰਟ।",
    medicationAlerts: "ਦਵਾਈ ਅਲਰਟ",
    medicationAlertsDesc: "ਸਮਾਰਟ ਰਿਮਾਈਂਡਰ, ਕੋਈ ਖੁਰਾਕ ਨਾ ਛੁੱਟੇ।",
    doctorAppointments: "ਡਾਕਟਰ ਅਪਾਇੰਟਮੈਂਟ",
    doctorAppointmentsDesc: "ਤੁਰੰਤ ਸੈਸ਼ਨ ਬੁੱਕ ਅਤੇ ਪ੍ਰਬੰਧਿਤ ਕਰੋ।",
    ...buildSwitchCredentialLoginLabel("ਪਾਸਵਰਡ ਲਾਗਇਨ 'ਤੇ ਜਾਓ"),
    secureAccess: "ਸੁਰੱਖਿਅਤ ਐਨਕ੍ਰਿਪਟਡ ਐਕਸੈਸ",
    pleaseLoginToContinue: "ਜਾਰੀ ਰੱਖਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਲਾਗਇਨ ਕਰੋ",
  },
  te: {
    betterMeTitle: "మంచి ఆరోగ్యం ఇక్కడే ప్రారంభం",
    welcomeSubtitle: "స్వాగతం! కొనసాగడానికి సైన్ అప్ లేదా లాగిన్ చేయండి",
    progressTracking: "ప్రగతి ట్రాకింగ్",
    progressTrackingDesc: "మీ ఆరోగ్య వైటల్స్ కోసం విజువల్ చార్ట్లు.",
    medicationAlerts: "మందు అలర్ట్లు",
    medicationAlertsDesc: "స్మార్ట్ రిమైండర్లు, మోతాదు మిస్ కాకుండా.",
    doctorAppointments: "డాక్టర్ అపాయింట్‌మెంట్లు",
    doctorAppointmentsDesc: "తక్షణం సెషన్లు బుక్ మరియు నిర్వహించండి.",
    ...buildSwitchCredentialLoginLabel("పాస్‌వర్డ్ లాగిన్‌కు మారండి"),
    secureAccess: "సురక్షిత ఎన్క్రిప్టెడ్ యాక్సెస్",
    pleaseLoginToContinue: "కొనసాగడానికి దయచేసి లాగిన్ చేయండి",
  },
  ta: {
    betterMeTitle: "சிறந்த ஆரோக்கியம் இங்கே தொடங்குகிறது",
    welcomeSubtitle: "வரவேற்கிறோம்! தொடர பதிவு அல்லது உள்நுழையவும்",
    progressTracking: "முன்னேற்ற கண்காணிப்பு",
    progressTrackingDesc: "உங்கள் ஆரோக்கிய வைட்டல்களுக்கான விளக்கப்படங்கள்.",
    medicationAlerts: "மருந்து எச்சரிக்கைகள்",
    medicationAlertsDesc: "ஸ்மார்ட் நினைவூட்டல்கள், மருந்து தவறாது.",
    doctorAppointments: "மருத்துவர் சந்திப்புகள்",
    doctorAppointmentsDesc: "உடனடியாக சந்திப்பு பதிவு மற்றும் நிர்வகிப்பு.",
    ...buildSwitchCredentialLoginLabel("கடவுச்சொல் உள்நுழைவுக்கு மாற்று"),
    secureAccess: "பாதுகாப்பான குறியாக்க அணுகல்",
    pleaseLoginToContinue: "தொடர உள்நுழையவும்",
  },
  mr: {
    betterMeTitle: "चांगले आरोग्य येथून सुरू",
    welcomeSubtitle: "स्वागत! पुढे जाण्यासाठी साइन अप किंवा लॉगिन करा",
    progressTracking: "प्रगती ट्रॅकिंग",
    progressTrackingDesc: "तुमच्या आरोग्य वाइटल्ससाठी व्हिज्युअल चार्ट.",
    medicationAlerts: "औषध सूचना",
    medicationAlertsDesc: "स्मार्ट रिमाइंडर, कोणतीही डोस चुकू देता नाही.",
    doctorAppointments: "डॉक्टर अपॉइंटमेंट",
    doctorAppointmentsDesc: "त्वरित सत्र बुक आणि व्यवस्थापित करा.",
    ...buildSwitchCredentialLoginLabel("पासवर्ड लॉगिनवर जा"),
    secureAccess: "सुरक्षित एनक्रिप्टेड प्रवेश",
    pleaseLoginToContinue: "पुढे जाण्यासाठी कृपया लॉगिन करा",
  },
  bn: {
    betterMeTitle: "ভালো স্বাস্থ্য এখান থেকে শুরু",
    welcomeSubtitle: "স্বাগত! চালিয়ে যেতে সাইন আপ বা লগইন করুন",
    progressTracking: "অগ্রগতি ট্র্যাকিং",
    progressTrackingDesc: "আপনার স্বাস্থ্য ভাইটালের ভিজ্যুয়াল চার্ট।",
    medicationAlerts: "ওষুধ সতর্কতা",
    medicationAlertsDesc: "স্মার্ট রিমাইন্ডার, কোনো ডোজ মিস হবে না।",
    doctorAppointments: "ডাক্তার অ্যাপয়েন্টমেন্ট",
    doctorAppointmentsDesc: "তৎক্ষণাৎ সেশন বুক ও পরিচালনা করুন।",
    ...buildSwitchCredentialLoginLabel("পাসওয়ার্ড লগইনে যান"),
    secureAccess: "নিরাপদ এনক্রিপ্টেড অ্যাক্সেস",
    pleaseLoginToContinue: "চালিয়ে যেতে লগইন করুন",
  },
  kn: {
    betterMeTitle: "ಉತ್ತಮ ಆರೋಗ್ಯ ಇಲ್ಲಿಂದ ಪ್ರಾರಂಭ",
    welcomeSubtitle: "ಸ್ವಾಗತ! ಮುಂದುವರಿಸಲು ಸೈನ್ ಅಪ್ ಅಥವಾ ಲಾಗಿನ್ ಮಾಡಿ",
    progressTracking: "ಪ್ರಗತಿ ಟ್ರ್ಯಾಕಿಂಗ್",
    progressTrackingDesc: "ನಿಮ್ಮ ಆರೋಗ್ಯ ವೈಟಲ್ಸ್‌ಗೆ ದೃಶ್ಯ ಚಾರ್ಟ್‌ಗಳು.",
    medicationAlerts: "ಔಷಧಿ ಎಚ್ಚರಿಕೆಗಳು",
    medicationAlertsDesc: "ಸ್ಮಾರ್ಟ್ ಜ್ಞಾಪನೆಗಳು, ಯಾವುದೇ ಡೋಸ್ ತಪ್ಪದು.",
    doctorAppointments: "ವೈದ್ಯರ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್",
    doctorAppointmentsDesc: "ತಕ್ಷಣ ಸೆಷನ್ ಬುಕ್ ಮತ್ತು ನಿರ್ವಹಿಸಿ.",
    ...buildSwitchCredentialLoginLabel("ಪಾಸ್‌ವರ್ಡ್ ಲಾಗಿನ್‌ಗೆ ಬದಲಾಯಿಸಿ"),
    secureAccess: "ಸುರಕ್ಷಿತ ಎನ್‌ಕ್ರಿಪ್ಟೆಡ್ ಪ್ರವೇಶ",
    pleaseLoginToContinue: "ಮುಂದುವರಿಸಲು ದಯವಿಟ್ಟು ಲಾಗಿನ್ ಮಾಡಿ",
  },
};

const AI_DASHBOARD = {
  pa: {
    goodMorning: "ਸ਼ੁਭ ਸਵੇਰ",
    takeCharge: "ਅੱਜ ਆਪਣੀ ਸਿਹਤ ਦਾ ਕੰਟਰੋਲ ਲਓ!",
    healthStatsToday: "ਅੱਜ ਤੁਹਾਡੇ ਸਿਹਤ ਅੰਕੜਿਆਂ ਬਾਰੇ ਜਾਣੋ।",
    secureRecords: "ਆਪਣੇ ਸਿਹਤ ਰਿਕਾਰਡ ਸੁਰੱਖਿਅਤ ਕਰੋ",
    checkVitals: "ਆਪਣੇ ਵਾਇਟਲ ਸੰਕੇਤ ਜਾਂਚੋ",
    uploadVital: "ਵਾਇਟਲ ਅਪਲੋਡ ਕਰੋ",
    vitalsReports: "ਵਾਇਟਲ ਰਿਪੋਰਟਾਂ",
    uploadReports: "ਰਿਪੋਰਟ ਅਪਲੋਡ ਕਰੋ",
    taraUploadHint: "ਵਿਸ਼ਲੇਸ਼ਣ ਦੇਖਣ ਲਈ ਡੈਸ਼ਬੋਰਡ ਤੋਂ ਰਿਪੋਰਟ ਅਪਲੋਡ ਕਰੋ ਜਾਂ ਇੱਥੇ ਫਾਈਲ ਜੋੜੋ।",
    openMedCloud: "ਮੈਡ ਕਲਾਉਡ ਖੋਲ੍ਹੋ",
    today: "ਅੱਜ",
    average: "ਔਸਤ",
    medicineTracker: "ਦਵਾਈ ਟ੍ਰੈਕਰ",
    allTasks: "ਸਾਰੇ ਕਾਰਜ",
    noMedicines: "ਕੋਈ ਦਵਾ ਉਪਲਬਧ ਨਹੀਂ",
    upcoming: "ਆਉਣ ਵਾਲਾ",
    taken: "ਲਿਆ ਹੋਇਆ",
    missed: "ਛੁੱਟ ਗਿਆ",
    markTaken: "ਲਿਆ ਚਿਹਨਿਤ ਕਰੋ",
    details: "ਵਿਵਰਣ",
    scheduled: "ਨਿਰਧਾਰਤ",
    noNotes: "ਕੋਈ ਨੋਟ ਨਹੀਂ",
    stepsGoal: "10,000 ਕਦਮ / ਦਿਨ",
    waterGoal: "6 ਲੀਟਰ ਪਾਣੀ / ਦਿਨ",
    sleepGoal: "8 ਘੰਟੇ ਨੀਂਦ / ਦਿਨ",
    days: "ਦਿਨ",
    fitnessGuide: "ਤੁਹਾਡਾ ਫਿਟਨੈਸ ਗਾਈਡ",
    beginnerYoga: "ਸ਼ੁਰੂਆਤੀ ਯੋਗਾ ਟਿਊਟੋਰਿਅਲ",
    yogaSubtitle: "ਸ਼ੁਰੂਆਤੀਆਂ ਲਈ ਯੋਗਾ",
    taraGuide: "ਤੁਹਾਡਾ ਤਾਰਾ ਗਾਈਡ",
    taraTagline: "ਸਿਹਤਮੰਦ ਭਵਿੱਖ ਵੱਲ ਰਾਹ",
    lowSpo2: "ਘੱਟ SpO₂",
    lowSpo2Desc: "ਤੁਹਾਡਾ SpO₂ ਸਧਾਰਨ ਤੋਂ ਘੱਟ ਹੈ। ਭਾਰੀ ਵਜ਼ਨ ਚੁੱਕਣ ਤੋਂ ਬਚੋ।",
    message: "ਸੁਨੇਹਾ",
    messagePlaceholder: "ਸੁਨੇਹਾ...",
    taraTyping: "@tara ਟਾਈਪ ਕਰ ਰਿਹਾ ਹੈ...",
    steps: "ਕਦਮ",
    calories: "ਕੈਲੋਰੀ",
    sleep: "ਨੀਂਦ",
    waterIntake: "ਪਾਣੀ ਦਾ ਸੇਵਨ",
    bloodPressure: "ਬਲੱਡ ਪ੍ਰੈਸ਼ਰ",
    heartRate: "ਦਿਲ ਦੀ ਧੜਕਣ",
    glucoseLevel: "ਗਲੂਕੋਜ਼ ਪੱਧਰ",
    oxygenSpo2: "ਆਕਸੀਜਨ SpO₂",
    stepsUnit: "ਕਦਮ",
    hoursUnit: "ਘੰਟੇ",
    mlUnit: "ਮਿ.ਲੀ.",
    calUnit: "ਕੈਲ",
    attachFile: "ਫਾਈਲ ਅਟੈਚ ਕਰੋ",
    tapToTalk: "ਬੋਲਣ ਲਈ ਟੈਪ ਕਰੋ"
  },
  te: {
    goodMorning: "శుభోదయం",
    takeCharge: "ఈరోజు మీ ఆరోగ్యాన్ని నియంత్రించండి!",
    healthStatsToday: "ఈరోజు మీ ఆరోగ్య గణాంకాలు ఇవి.",
    secureRecords: "మీ ఆరోగ్య రికార్డులను సురక్షితం చేయండి",
    checkVitals: "మీ వైటల్ సంకేతాలను తనిఖీ చేయండి",
    uploadVital: "వైటల్ అప్‌లోడ్ చేయండి",
    vitalsReports: "వైటల్ రిపోర్ట్లు",
    uploadReports: "రిపోర్ట్ అప్‌లోడ్ చేయండి",
    taraUploadHint: "విశ్లేషణ చూడటానికి డాష్‌బోర్డ్ నుండి రిపోర్ట్ అప్‌లోడ్ చేయండి లేదా ఇక్కడ ఫైల్ జోడించండి.",
    openMedCloud: "మెడ్ క్లౌడ్ తెరవండి",
    today: "ఈరోజు",
    average: "సగటు",
    medicineTracker: "మందు ట్రాకర్",
    allTasks: "అన్ని పనులు",
    noMedicines: "మందులు లేవు",
    upcoming: "రాబోయే",
    taken: "తీసుకున్నారు",
    missed: "మిస్ అయింది",
    markTaken: "తీసుకున్నట్లు గుర్తించండి",
    details: "వివరాలు",
    scheduled: "షెడ్యూల్",
    noNotes: "నోట్స్ లేవు",
    stepsGoal: "10,000 అడుగులు / రోజు",
    waterGoal: "6 లీటర్లు నీరు / రోజు",
    sleepGoal: "8 గంటల నిద్ర / రోజు",
    days: "రోజులు",
    fitnessGuide: "మీ ఫిట్నెస్ గైడ్",
    beginnerYoga: "బిగినర్ యోగా ట్యుటోరియల్",
    yogaSubtitle: "ప్రారంభకులకు యోగా",
    taraGuide: "మీ తారా గైడ్",
    taraTagline: "ఆరోగ్యకర భవిష్యత్తు వైపు దారి",
    lowSpo2: "తక్కువ SpO₂",
    lowSpo2Desc: "మీ SpO₂ సాధారణంగా తక్కువగా ఉంది. భారీ ఎత్తులు ఎత్తకండి.",
    message: "సందేశం",
    messagePlaceholder: "సందేశం...",
    taraTyping: "@tara టైప్ చేస్తోంది...",
    steps: "అడుగులు",
    calories: "క్యాలరీలు",
    sleep: "నిద్ర",
    waterIntake: "నీటి తీసుకోవడం",
    bloodPressure: "రక్తపోటు",
    heartRate: "గుండె చప్పుడు",
    glucoseLevel: "గ్లూకోజ్ స్థాయి",
    oxygenSpo2: "ఆక్సిజన్ SpO₂",
    stepsUnit: "అడుగులు",
    hoursUnit: "గంటలు",
    mlUnit: "మి.లీ.",
    calUnit: "క్యాల",
    attachFile: "ఫైల్‌ను జతచేయండి",
    tapToTalk: "మాట్లాడటానికి ట్యాప్ చేయండి"
  },
  ta: {
    goodMorning: "காலை வணக்கம்",
    takeCharge: "இன்று உங்கள் ஆரோக்கியத்தை கட்டுப்படுத்துங்கள்!",
    healthStatsToday: "இன்று உங்கள் ஆரோக்கிய புள்ளிவிவரங்கள்.",
    secureRecords: "உங்கள் சுகாதார பதிவுகளைப் பாதுகாக்கவும்",
    checkVitals: "உங்கள் வைட்டல் அறிகுறிகளை சரிபார்க்கவும்",
    uploadVital: "வைட்டல் பதிவேற்றம்",
    vitalsReports: "வைட்டல் அறிக்கைகள்",
    uploadReports: "அறிக்கையை பதிவேற்று",
    taraUploadHint: "பகுப்பாய்வைப் பார்க்க டாஷ்போர்டிலிருந்து அறிக்கையை பதிவேற்றவும் அல்லது இங்கே கோப்பை இணைக்கவும்.",
    openMedCloud: "மெட் கிளவுட் திற",
    today: "இன்று",
    average: "சராசரி",
    medicineTracker: "மருந்து டிராக்கர்",
    allTasks: "அனைத்து பணிகள்",
    noMedicines: "மருந்துகள் இல்லை",
    upcoming: "வரவிருக்கும்",
    taken: "எடுத்துக்கொண்டது",
    missed: "தவறியது",
    markTaken: "எடுத்ததாகக் குறி",
    details: "விவரங்கள்",
    scheduled: "திட்டமிடப்பட்ட",
    noNotes: "குறிப்புகள் இல்லை",
    stepsGoal: "10,000 படிகள் / நாள்",
    waterGoal: "6 லிட்டர் தண்ணீர் / நாள்",
    sleepGoal: "8 மணி தூக்கம் / நாள்",
    days: "நாட்கள்",
    fitnessGuide: "உங்கள் உடற்பயிற்சி வழிகாட்டி",
    beginnerYoga: "தொடக்க யோகா பயிற்சி",
    yogaSubtitle: "ஆரம்பிப்போருக்கான யோகா",
    taraGuide: "உங்கள் தாரா வழிகாட்டி",
    taraTagline: "ஆரோக்கியமான எதிர்காலத்திற்கான வழி",
    lowSpo2: "குறைந்த SpO₂",
    lowSpo2Desc: "உங்கள் SpO₂ குறைவாக உள்ளது. கனமான பொருட்களை தூக்க வேண்டாம்.",
    message: "செய்தி",
    messagePlaceholder: "செய்தி...",
    taraTyping: "@tara தட்டச்சு செய்கிறது...",
    steps: "படிகள்",
    calories: "கலோரிகள்",
    sleep: "தூக்கம்",
    waterIntake: "நீர் உட்கொள்ளல்",
    bloodPressure: "இரத்த அழுத்தம்",
    heartRate: "இதய துடிப்பு",
    glucoseLevel: "குளுக்கோஸ் அளவு",
    oxygenSpo2: "ஆக்ஸிஜன் SpO₂",
    stepsUnit: "படிகள்",
    hoursUnit: "மணி",
    mlUnit: "மி.லி.",
    calUnit: "கலோ",
    attachFile: "கோப்பை இணைக்கவும்",
    tapToTalk: "பேச தட்டவும்"
  },
  mr: {
    goodMorning: "शुभ प्रभात",
    takeCharge: "आज तुमच्या आरोग्यावर नियंत्रण ठेवा!",
    healthStatsToday: "आज तुमच्या आरोग्य आकडेवारीबद्दल जाणून घ्या.",
    secureRecords: "तुमचे आरोग्य रेकॉर्ड सुरक्षित करा",
    checkVitals: "तुमचे वाइटल चिन्ह तपासा",
    uploadVital: "वाइटल अपलोड करा",
    vitalsReports: "व्हायटल अहवाल",
    uploadReports: "अहवाल अपलोड करा",
    taraUploadHint: "विश्लेषण पाहण्यासाठी डॅशबोर्डवरून अहवाल अपलोड करा किंवा येथे फाइल जोडा.",
    openMedCloud: "मेड क्लाउड उघडा",
    today: "आज",
    average: "सरासरी",
    medicineTracker: "औषध ट्रॅकर",
    allTasks: "सर्व कार्ये",
    noMedicines: "औषधे उपलब्ध नाहीत",
    upcoming: "येणारे",
    taken: "घेतले",
    missed: "चुकले",
    markTaken: "घेतले म्हणून चिन्हांकित करा",
    details: "तपशील",
    scheduled: "नियोजित",
    noNotes: "टिपा नाहीत",
    stepsGoal: "10,000 पावले / दिवस",
    waterGoal: "6 लिटर पाणी / दिवस",
    sleepGoal: "8 तास झोप / दिवस",
    days: "दिवस",
    fitnessGuide: "तुमचा फिटनेस मार्गदर्शक",
    beginnerYoga: "नवशिक्यांसाठी योगा",
    yogaSubtitle: "सुरुवातीसाठी योगा",
    taraGuide: "तुमचा तारा मार्गदर्शक",
    taraTagline: "निरोगी भविष्याकडे मार्ग",
    lowSpo2: "कमी SpO₂",
    lowSpo2Desc: "तुमचा SpO₂ सामान्यपेक्षा कमी आहे. जड वजन उचलू नका.",
    message: "संदेश",
    messagePlaceholder: "संदेश...",
    taraTyping: "@tara टाइप करत आहे...",
    steps: "पावले",
    calories: "कॅलरी",
    sleep: "झोप",
    waterIntake: "पाणी सेवन",
    bloodPressure: "रक्तदाब",
    heartRate: "हृदयगती",
    glucoseLevel: "ग्लुकोज पातळी",
    oxygenSpo2: "ऑक्सिजन SpO₂",
    stepsUnit: "पावले",
    hoursUnit: "तास",
    mlUnit: "मि.ली.",
    calUnit: "कॅल",
    attachFile: "फाइल जोडा",
    tapToTalk: "बोलण्यासाठी टॅप करा"
  },
  bn: {
    goodMorning: "সুপ্রভাত",
    takeCharge: "আজ আপনার স্বাস্থ্যের নিয়ন্ত্রণ নিন!",
    healthStatsToday: "আজ আপনার স্বাস্থ্য পরিসংখ্যান এখানে।",
    secureRecords: "আপনার স্বাস্থ্য রেকর্ড সুরক্ষিত করুন",
    checkVitals: "আপনার ভাইটাল লক্ষণ পরীক্ষা করুন",
    uploadVital: "ভাইটাল আপলোড করুন",
    vitalsReports: "ভাইটাল রিপোর্ট",
    uploadReports: "রিপোর্ট আপলোড করুন",
    taraUploadHint: "বিশ্লেষণ দেখতে ড্যাশবোর্ড থেকে রিপোর্ট আপলোড করুন বা এখানে ফাইল সংযুক্ত করুন।",
    openMedCloud: "মেড ক্লাউড খুলুন",
    today: "আজ",
    average: "গড়",
    medicineTracker: "ওষুধ ট্র্যাকার",
    allTasks: "সব কাজ",
    noMedicines: "কোনো ওষুধ নেই",
    upcoming: "আসন্ন",
    taken: "নেওয়া হয়েছে",
    missed: "মিস হয়েছে",
    markTaken: "নেওয়া হিসাবে চিহ্নিত",
    details: "বিবরণ",
    scheduled: "নির্ধারিত",
    noNotes: "কোনো নোট নেই",
    stepsGoal: "১০,০০০ পা / দিন",
    waterGoal: "৬ লিটার পানি / দিন",
    sleepGoal: "৮ ঘণ্টা ঘুম / দিন",
    days: "দিন",
    fitnessGuide: "আপনার ফিটনেস গাইড",
    beginnerYoga: "শুরুর যোগা টিউটোরিয়াল",
    yogaSubtitle: "নতুনদের জন্য যোগা",
    taraGuide: "আপনার তারা গাইড",
    taraTagline: "সুস্থ ভবিষ্যতের পথ",
    lowSpo2: "কম SpO₂",
    lowSpo2Desc: "আপনার SpO₂ স্বাভাবিকের চেয়ে কম। ভারী ওজন তোলা এড়িয়ে চলুন।",
    message: "বার্তা",
    messagePlaceholder: "বার্তা...",
    taraTyping: "@tara টাইপ করছে...",
    steps: "পা",
    calories: "ক্যালোরি",
    sleep: "ঘুম",
    waterIntake: "পানি গ্রহণ",
    bloodPressure: "রক্তচাপ",
    heartRate: "হৃদস্পন্দন",
    glucoseLevel: "গ্লুকোজ স্তর",
    oxygenSpo2: "অক্সিজেন SpO₂",
    stepsUnit: "পা",
    hoursUnit: "ঘণ্টা",
    mlUnit: "মি.লি.",
    calUnit: "ক্যাল",
    attachFile: "ফাইল সংযুক্ত করুন",
    tapToTalk: "কথা বলতে ট্যাপ করুন"
  },
  kn: {
    goodMorning: "ಶುಭೋದಯ",
    takeCharge: "ಇಂದು ನಿಮ್ಮ ಆರೋಗ್ಯವನ್ನು ನಿಯಂತ್ರಿಸಿ!",
    healthStatsToday: "ಇಂದು ನಿಮ್ಮ ಆರೋಗ್ಯ ಅಂಕಿಅಂಶಗಳು ಇಲ್ಲಿವೆ.",
    secureRecords: "ನಿಮ್ಮ ಆರೋಗ್ಯ ದಾಖಲೆಗಳನ್ನು ಸುರಕ್ಷಿತಗೊಳಿಸಿ",
    checkVitals: "ನಿಮ್ಮ ವೈಟಲ್ ಚಿಹ್ನೆಗಳನ್ನು ಪರಿಶೀಲಿಸಿ",
    uploadVital: "ವೈಟಲ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    vitalsReports: "ವೈಟಲ್ ವರದಿಗಳು",
    uploadReports: "ವರದಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    taraUploadHint: "ವಿಶ್ಲೇಷಣೆ ನೋಡಲು ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ನಿಂದ ವರದಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ ಅಥವಾ ಇಲ್ಲಿ ಫೈಲ್ ಲಗತ್ತಿಸಿ.",
    openMedCloud: "ಮೆಡ್ ಕ್ಲೌಡ್ ತೆರೆಯಿರಿ",
    today: "ಇಂದು",
    average: "ಸರಾಸರಿ",
    medicineTracker: "ಔಷಧಿ ಟ್ರ್ಯಾಕರ್",
    allTasks: "ಎಲ್ಲಾ ಕಾರ್ಯಗಳು",
    noMedicines: "ಔಷಧಿಗಳಿಲ್ಲ",
    upcoming: "ಮುಂದಿನ",
    taken: "ತೆಗೆದುಕೊಂಡಿದೆ",
    missed: "ತಪ್ಪಿದೆ",
    markTaken: "ತೆಗೆದುಕೊಂಡಂತೆ ಗುರುತಿಸಿ",
    details: "ವಿವರಗಳು",
    scheduled: "ನಿಗದಿತ",
    noNotes: "ಟಿಪ್ಪಣಿಗಳಿಲ್ಲ",
    stepsGoal: "೧೦,೦೦೦ ಹೆಜ್ಜೆಗಳು / ದಿನ",
    waterGoal: "೬ ಲೀಟರ್ ನೀರು / ದಿನ",
    sleepGoal: "೮ ಗಂಟೆ ನಿದ್ರೆ / ದಿನ",
    days: "ದಿನಗಳು",
    fitnessGuide: "ನಿಮ್ಮ ಫಿಟ್ನೆಸ್ ಗೈಡ್",
    beginnerYoga: "ಆರಂಭಿಕ ಯೋಗ ಟ್ಯುಟೋರಿಯಲ್",
    yogaSubtitle: "ಆರಂಭಿಕರಿಗೆ ಯೋಗ",
    taraGuide: "ನಿಮ್ಮ ತಾರಾ ಗೈಡ್",
    taraTagline: "ಆರೋಗ್ಯಕರ ಭವಿಷ್ಯದ ಮಾರ್ಗ",
    lowSpo2: "ಕಡಿಮೆ SpO₂",
    lowSpo2Desc: "ನಿಮ್ಮ SpO₂ ಸಾಮಾನ್ಯಕ್ಕಿಂತ ಕಡಿಮೆ. ಭಾರ ಎತ್ತುವುದನ್ನು ತಪ್ಪಿಸಿ.",
    message: "ಸಂದೇಶ",
    messagePlaceholder: "ಸಂದೇಶ...",
    taraTyping: "@tara ಟೈಪ್ ಮಾಡುತ್ತಿದೆ...",
    steps: "ಹೆಜ್ಜೆಗಳು",
    calories: "ಕ್ಯಾಲೊರಿಗಳು",
    sleep: "ನಿದ್ರೆ",
    waterIntake: "ನೀರಿನ ಸೇವನೆ",
    bloodPressure: "ರಕ್ತದೊತ್ತಡ",
    heartRate: "ಹೃದಯ ಬಡಿತ",
    glucoseLevel: "ಗ್ಲೂಕೋಸ್ ಮಟ್ಟ",
    oxygenSpo2: "ಆಮ್ಲಜನಕ SpO₂",
    stepsUnit: "ಹೆಜ್ಜೆಗಳು",
    hoursUnit: "ಗಂಟೆಗಳು",
    mlUnit: "ಮಿ.ಲೀ.",
    calUnit: "ಕ್ಯಾಲ",
    attachFile: "ಫೈಲ್ ಲಗತ್ತಿಸಿ",
    tapToTalk: "ಮಾತನಾಡಲು ಟ್ಯಾಪ್ ಮಾಡಿ"
  },
};

const REGISTER_PAGE = {
  pa: {
    title: "ਨਵੀਂ ਮੈਂਬਰਸ਼ਿਪ ਰਜਿਸਟਰ ਕਰੋ",
    disclaimer:
      "ਇਹ ਟੂਲ ਸਿਰਫ਼ ਸਿੱਖਿਆ ਉਦੇਸ਼ਾਂ ਲਈ ਹੈ। ਸਾਡੀ AI ਡਾਕਟਰ ਨਹੀਂ ਹੈ ਅਤੇ ਡਾਇਗਨੋਸਿਸ ਜਾਂ ਇਲਾਜ ਨਹੀਂ ਦੇ ਸਕਦੀ। ਨਤੀਜੇ ਸਿਰਫ਼ ਤੁਹਾਡੀ ਸਾਂਝੀ ਜਾਣਕਾਰੀ 'ਤੇ ਆਧਾਰਿਤ ਹਨ। ਡਾਕਟਰੀ ਸਲਾਹ ਲਈ ਲਾਇਸੈਂਸਡ ਪ੍ਰੋਫੈਸ਼ਨਲ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    alreadyHaveAccount: "ਪਹਿਲਾਂ ਤੋਂ ਖਾਤਾ ਹੈ?",
    signIn: "ਸਾਈਨ ਇਨ",
  },
  te: {
    title: "కొత్త సభ్యత్వం నమోదు చేయండి",
    disclaimer:
      "ఈ సాధనం విద్యా ప్రయోజనాల కోసం మాత్రమే. మా AI డాక్టర్ కాదు; వైద్య నిర్ధారణ లేదా చికిత్స ఇవ్వదు. ఫలితాలు మీరు షేర్ చేసిన సమాచారంపై ఆధారపడి ఉంటాయి. వైద్య సలహ కోసం నిపుణులను సంప్రదించండి.",
    alreadyHaveAccount: "ఇప్పటికే ఖాతా ఉందా?",
    signIn: "సైన్ ఇన్",
  },
  ta: {
    title: "புதிய உறுப்பினர் பதிவு",
    disclaimer:
      "இந்த கருவி கல்வி நோக்கங்களுக்காக மட்டுமே. எங்கள் AI மருத்துவர் அல்ல; நோயறிதல் அல்லது சிகிச்சை வழங்காது. முடிவுகள் நீங்கள் பகிர்ந்த தகவலைச் சார்ந்தவை. மருத்துவ ஆலோசனைக்கு நிபுணரை அணுகவும்.",
    alreadyHaveAccount: "ஏற்கனவே கணக்கு உள்ளதா?",
    signIn: "உள்நுழை",
  },
  mr: {
    title: "नवीन सदस्यत्व नोंदणी",
    disclaimer:
      "हे साधन केवळ शैक्षणिक उद्देशांसाठी आहे. आमची AI डॉक्टर नाही; निदान किंवा उपचार देत नाही. निकाल तुम्ही शेअर केलेल्या माहितीवर आधारित आहेत. वैद्यकीय सल्ल्यासाठी तज्ज्ञांशी संपर्क साधा.",
    alreadyHaveAccount: "आधीच खाते आहे?",
    signIn: "साइन इन",
  },
  bn: {
    title: "নতুন সদস্যপদ নিবন্ধন",
    disclaimer:
      "এই সরঞ্জাম শুধুমাত্র শিক্ষামূলক উদ্দেশ্যে। আমাদের AI ডাক্তার নয়; রোগ নির্ণয় বা চিকিৎসা দেয় না। ফলাফল আপনার শেয়ার করা তথ্যের উপর নির্ভর করে। চিকিৎসা পরামর্শের জন্য বিশেষজ্ঞের সাথে যোগাযোগ করুন।",
    alreadyHaveAccount: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
    signIn: "সাইন ইন",
  },
  kn: {
    title: "ಹೊಸ ಸದಸ್ಯತ್ವ ನೋಂದಣಿ",
    disclaimer:
      "ಈ ಸಾಧನ ಶೈಕ್ಷಣಿಕ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಮಾತ್ರ. ನಮ್ಮ AI ವೈದ್ಯರಲ್ಲ; ರೋಗನಿರ್ಣಯ ಅಥವಾ ಚಿಕಿತ್ಸೆ ನೀಡುವುದಿಲ್ಲ. ಫಲಿತಾಂಶಗಳು ನೀವು ಹಂಚಿದ ಮಾಹಿತಿಯ ಮೇಲೆ ಅವಲಂಬಿತ. ವೈದ್ಯಕೀಯ ಸಲಹೆಗೆ ತಜ್ಞರನ್ನು ಸಂಪರ್ಕಿಸಿ.",
    alreadyHaveAccount: "ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯೇ?",
    signIn: "ಸೈನ್ ಇನ್",
  },
};

const TARA_REPORTS = {
  pa: {
    pageTitle: "ਰਿਪੋਰਟਾਂ",
    myTaraReports: "ਮਾਈਤਾਰਾ ਰਿਪੋਰਟਾਂ",
    aiChatSummary: "AI ਚੈਟ ਸਾਰਾਂਸ਼",
    healthCareSummary: "ਸਿਹਤ ਸਾਰਾਂਸ਼",
    searchPlaceholder: "ਖੋਜੋ...",
    month: "ਮਹੀਨਾ",
    year: "ਸਾਲ",
    loadingSummaries: "ਸਾਰਾਂਸ਼ ਲੋਡ ਹੋ ਰਹੇ ਹਨ...",
    failedToLoad: "ਸਾਰਾਂਸ਼ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
    noData: "ਕੋਈ ਡੇਟਾ ਨਹੀਂ",
    totalReports: "ਕੁੱਲ {count} ਰਿਪੋਰਟਾਂ",
    dateTime: "ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ",
    aiSolutionSummary: "AI ਹੱਲ ਸਾਰਾਂਸ਼",
    problemStatement: "ਸਮੱਸਿਆ ਬਿਆਨ",
    chatLogs: "ਚੈਟ ਲੌਗ",
  },
  te: {
    pageTitle: "రిపోర్ట్లు",
    myTaraReports: "మైతారా రిపోర్ట్లు",
    aiChatSummary: "AI చాట్ సారాంశం",
    healthCareSummary: "ఆరోగ్య సారాంశం",
    searchPlaceholder: "వెతకండి...",
    month: "నెల",
    year: "సంవత్సరం",
    loadingSummaries: "సారాంశాలు లోడ్ అవుతున్నాయి...",
    failedToLoad: "సారాంశాలు లోడ్ కాలేదు.",
    noData: "డేటా లేదు",
    totalReports: "మొత్తం {count} రిపోర్ట్లు",
    dateTime: "తేదీ మరియు సమయం",
    aiSolutionSummary: "AI పరిష్కార సారాంశం",
    problemStatement: "సమస్య వివరణ",
    chatLogs: "చాట్ లాగ్‌లు",
  },
  ta: {
    pageTitle: "அறிக்கைகள்",
    myTaraReports: "மைதாரா அறிக்கைகள்",
    aiChatSummary: "AI அரட்டை சுருக்கம்",
    healthCareSummary: "சுகாதார சுருக்கம்",
    searchPlaceholder: "தேடு...",
    month: "மாதம்",
    year: "ஆண்டு",
    loadingSummaries: "சுருக்கங்கள் ஏற்றப்படுகின்றன...",
    failedToLoad: "சுருக்கங்களை ஏற்ற முடியவில்லை.",
    noData: "தரவு இல்லை",
    totalReports: "மொத்தம் {count} அறிக்கைகள்",
    dateTime: "தேதி மற்றும் நேரம்",
    aiSolutionSummary: "AI தீர்வு சுருக்கம்",
    problemStatement: "பிரச்சனை விவரம்",
    chatLogs: "அரட்டை பதிவுகள்",
  },
  mr: {
    pageTitle: "अहवाल",
    myTaraReports: "मायतारा अहवाल",
    aiChatSummary: "AI चॅट सारांश",
    healthCareSummary: "आरोग्य सारांश",
    searchPlaceholder: "शोधा...",
    month: "महिना",
    year: "वर्ष",
    loadingSummaries: "सारांश लोड होत आहेत...",
    failedToLoad: "सारांश लोड करण्यात अयशस्वी.",
    noData: "डेटा नाही",
    totalReports: "एकूण {count} अहवाल",
    dateTime: "दिनांक आणि वेळ",
    aiSolutionSummary: "AI उपाय सारांश",
    problemStatement: "समस्या विवरण",
    chatLogs: "चॅट लॉग",
  },
  bn: {
    pageTitle: "রিপোর্ট",
    myTaraReports: "মাইতারা রিপোর্ট",
    aiChatSummary: "AI চ্যাট সারাংশ",
    healthCareSummary: "স্বাস্থ্য সারাংশ",
    searchPlaceholder: "খুঁজুন...",
    month: "মাস",
    year: "বছর",
    loadingSummaries: "সারাংশ লোড হচ্ছে...",
    failedToLoad: "সারাংশ লোড ব্যর্থ।",
    noData: "কোনো ডেটা নেই",
    totalReports: "মোট {count} রিপোর্ট",
    dateTime: "তারিখ ও সময়",
    aiSolutionSummary: "AI সমাধান সারাংশ",
    problemStatement: "সমস্যার বিবরণ",
    chatLogs: "চ্যাট লগ",
  },
  kn: {
    pageTitle: "ವರದಿಗಳು",
    myTaraReports: "ಮೈತಾರಾ ವರದಿಗಳು",
    aiChatSummary: "AI ಚಾಟ್ ಸಾರಾಂಶ",
    healthCareSummary: "ಆರೋಗ್ಯ ಸಾರಾಂಶ",
    searchPlaceholder: "ಹುಡುಕಿ...",
    month: "ತಿಂಗಳು",
    year: "ವರ್ಷ",
    loadingSummaries: "ಸಾರಾಂಶಗಳು ಲೋಡ್ ಆಗುತ್ತಿವೆ...",
    failedToLoad: "ಸಾರಾಂಶ ಲೋಡ್ ವಿಫಲವಾಯಿತು.",
    noData: "ಡೇಟಾ ಇಲ್ಲ",
    totalReports: "ಒಟ್ಟು {count} ವರದಿಗಳು",
    dateTime: "ದಿನಾಂಕ ಮತ್ತು ಸಮಯ",
    aiSolutionSummary: "AI ಪರಿಹಾರ ಸಾರಾಂಶ",
    problemStatement: "ಸಮಸ್ಯೆ ವಿವರಣೆ",
    chatLogs: "ಚಾಟ್ ಲಾಗ್‌ಗಳು",
  },
};

export const applyAuthDashboardLocales = (translations) => {
  Object.entries(AUTH_MODAL).forEach(([lang, authModal]) => {
    if (!translations[lang]) return;
    translations[lang].authModal = {
      ...translations[lang].authModal,
      ...authModal,
    };
  });
  Object.entries(AI_DASHBOARD).forEach(([lang, aiDashboard]) => {
    if (!translations[lang]) return;
    translations[lang].aiDashboard = {
      ...translations[lang].aiDashboard,
      ...aiDashboard,
    };
  });
  Object.entries(REGISTER_PAGE).forEach(([lang, register]) => {
    if (!translations[lang]) return;
    translations[lang].register = {
      ...translations[lang].register,
      ...register,
    };
  });
  Object.entries(TARA_REPORTS).forEach(([lang, taraReports]) => {
    if (!translations[lang]) return;
    translations[lang].taraReports = {
      ...translations[lang].taraReports,
      ...taraReports,
    };
  });
};
